exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".y2t_TY1sU4IeRB51sP5E{position:relative}._3PgYj9ga9yKHS3g1Znc3f1{position:absolute;top:0;height:100%;width:100%}html[dir=ltr] ._3PgYj9ga9yKHS3g1Znc3f1{left:0}html[dir=rtl] ._3PgYj9ga9yKHS3g1Znc3f1{right:0}", ""]);
// Exports
exports.locals = {
	"main": "y2t_TY1sU4IeRB51sP5E",
	"object": "_3PgYj9ga9yKHS3g1Znc3f1"
};